import { createTheme } from '@material-ui/core/styles';
import * as R from 'ramda';

import baseTheme, { baseMuiTheme } from './base-theme';

export const muiTheme = createTheme(baseMuiTheme);

export default R.mergeDeepRight(baseTheme, {
  name: 'Appeals',
  header: {
    background: '#b6c8e3',
  },
});
